import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface ShareHeaderProps {
  invert?: boolean;
}
/**
 * This header is never visible for the user, it's only used when sharing the insight
 */
export function ShareHeader(props: ShareHeaderProps) {
  const { invert = false } = props;

  return (
    <Stack
      id="share-header"
      sx={(theme) => ({
        flexDirection: "row",
        gap: 3,
        paddingX: 5,
        alignItems: "center",
        opacity: 0,
        position: "absolute",
        top: theme.spacing(3),
        left: 0,
        right: 0,
      })}
    >
      <CbhIcon type="clipboard-bunny-colored" size="xLarge" />

      <Text
        semibold
        variant="h4"
        sx={(theme) => ({
          textWrap: "balance",
          color: invert ? theme.palette.text.invertPrimary : theme.palette.text.primary,
        })}
      >
        My 2025 Mid-Year Recap
      </Text>
    </Stack>
  );
}
